export const AutoSecondarySidebar = () => {
  return null
}
